import produce from "immer";

import { TaskTypes } from "../../../constants/task-types";
import { CameraImage, CameraODImage } from "../../../entities/Camera";

const imageTypeToCameraImageObj = {
  [TaskTypes.CLASSIFICATION]: CameraImage.fromApi,
  [TaskTypes.OBJECT_DETECTION]: CameraODImage.fromApi,
  [TaskTypes.SEGMENTATION]: CameraODImage.fromApi,
};

export const mapImagesToCameraImages = (imagesData, imagesType) => {
  const { data, current_page, page_limit } = imagesData;
  const id = (current_page - 1) * page_limit;
  let mapper = imageTypeToCameraImageObj[imagesType] ?? null;
  return mapper && data.map((image, index) => mapper(image, index + id));
};

export const mapSingleImageToCameraImage = (imageData, imageType) => {
  const mapper = imageTypeToCameraImageObj[imageType] ?? null;
  return mapper && mapper(imageData);
};

export const cameraActions = {
  prediction: "image-stream::prediction-label",
  test_connection: "image-stream::test-connection",
};

/**
 *
 * @param {typeof initialState.streaming} state
 * @param {string} message
 * @param {*} payload
 * @returns
 */
export const cameraWebSocket = (state, type, payload) => {
  return produce(state, (draft) => {
    let mapper = imageTypeToCameraImageObj[type] ?? null;
    draft.prediction = mapper && mapper(payload);
  });
};
